import React from 'react';
import { PageLanguageContextProps } from './PageLanguageContext.types';
import { defaultLanguage } from '../../settings';

const initalState: PageLanguageContextProps = {
	activeLanguage: defaultLanguage,
	setLanguage: () => {}
};

export const PageLanguageContext = React.createContext<PageLanguageContextProps>(initalState);